export default $(()=>{

    let $topic = $('body#page-company-contact-us select#contactFormTopic');
    let $application = $('body#page-company-contact-us label[for=contactFormProductApplication]');
    let $product = $('body#page-company-contact-us label[for=contactFormSpecificProduct]');


    $topic.on('change', function() {
        if ($(this).val() == 'Product Questions') {
            $application.children().show().find('select').prop('disabled', false);
            $product.show().find('input').prop('disabled', false);
        } else {
            $application.children().hide().find('select').prop('disabled', true);
            $product.hide().find('input').prop('disabled', true);
        }
    }).triggerHandler('change');

});